export const categories = [
  {
    id: 1,
    name: 'Fashion',
  },
  {
    id: 2,
    name: 'Home & Interior',
  },
  {
    id: 3,
    name: 'Beauty & Health',
  },
  {
    id: 4,
    name: 'Electronics & Computers',
  },
  {
    id: 5,
    name: 'Children & Baby',
  },
  {
    id: 6,
    name: 'Sports & Outdoors',
  },
  {
    id: 7,
    name: 'Books & Games',
  },
  {
    id: 8,
    name: 'Food & Beverage',
  },
  {
    id: 9,
    name: 'Other',
  },
]

export const locale = [
  { label: 'DE', value: 'DE' },
  { label: 'DK', value: 'DK' },
  { label: 'GB', value: 'GB' },
  { label: 'IT', value: 'IT' },
  { label: 'NO', value: 'NO' },
  { label: 'PL', value: 'PL' },
  { label: 'SE', value: 'SE' },
  { label: 'ES', value: 'ES' },
  { label: 'FR', value: 'FR' },
  { label: 'NL', value: 'NL' },
]

export const currency = [
  { label: 'SEK', value: 'SEK' },
  { label: 'DKK', value: 'DKK' },
  { label: 'EUR', value: 'EUR' },
  { label: 'NOK', value: 'NOK' },
  { label: 'PLN', value: 'PLN' },
  { label: 'GBP', value: 'GBP' },
]

export const currencyByLocale = {
  DE: 'EUR',
  DK: 'DKK',
  GB: 'GBP',
  FI: 'EUR',
  IT: 'EUR',
  NO: 'NOK',
  PL: 'PLN',
  SE: 'SEK',
  ES: 'EUR',
  FR: 'EUR',
  US: 'USD',
  NL: 'EUR',
}

export const languages = [
  { label: 'Danish', value: 'Danish' },
  { label: 'Deutsch', value: 'Deutsch' },
  { label: 'English', value: 'English' },
  { label: 'Finnish', value: 'Finnish' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Norwegian', value: 'Norwegian' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Swedish', value: 'Swedish' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'France', value: 'France' },
]

export const langCodeByName = {
  Danish: 'da',
  Deutsch: 'de',
  English: 'en',
  Finnish: 'fi',
  Italian: 'it',
  Norwegian: 'no',
  Polish: 'pl',
  Swedish: 'sv',
  Spanish: 'es',
  France: 'fr',
}

export const maxLogoFileSizeInBytes = 100000

export const InfluencerStatus = {
  ACCEPTED: 'accepted',
  SUSPENDED: 'suspended',
  UNDECIDED: 'undecided',
}
Object.freeze(InfluencerStatus)

export const influencerStatuses = Object.values(InfluencerStatus).map((status) => ({
  name: status.charAt(0).toUpperCase() + status.slice(1),
  value: status,
}))

export const StatisticTypes = {
  ORDER_VALUE: 'order_value',
  NR_OF_ORDERS: 'nr_orders',
  CLICKS: 'clicks',
  ESTIMATED_COST: 'estimated_cost',
}
Object.freeze(StatisticTypes)

export const InfluencerFullDataStatuses = {
  NO_CONTENT: 'no-content',
  IS_DOWNLOADING: 'Is downloading',
  READY: 'ready',
}

export const utmTags = {
  'Utm campaign': {
    value: 'Utm campaign',
    label: 'Utm campaign',
    example: 'E.g 20%Off',
    name: 'campaign',
    code: 'utm_campaign',
  },
  'Utm medium': {
    value: 'Utm medium',
    label: 'Utm medium',
    example: 'E.g socialmedia',
    name: 'medium',
    code: 'utm_medium',
  },
  'Utm source': {
    default: 'metapic',
    value: 'Utm source',
    label: 'Utm source',
    example: 'E.g metapic',
    name: 'source',
    code: 'utm_source',
  },
  'Utm Piece of Content': {
    value: 'Utm Piece of Content',
    label: 'Utm Piece of Content',
    example: 'E.g sidebar',
    name: 'content',
    code: 'utm_content',
  },
  'Utm term': {
    value: 'Utm term',
    label: 'Utm term',
    example: 'E.g comfortable+heels',
    name: 'term',
    code: 'utm_term',
  },
}
